import { render, staticRenderFns } from "./StoreItem.vue?vue&type=template&id=569ef91e&scoped=true&"
import script from "./StoreItem.vue?vue&type=script&lang=js&"
export * from "./StoreItem.vue?vue&type=script&lang=js&"
import style0 from "./StoreItem.vue?vue&type=style&index=0&id=569ef91e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "569ef91e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1771009219/src/capas-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('569ef91e')) {
      api.createRecord('569ef91e', component.options)
    } else {
      api.reload('569ef91e', component.options)
    }
    module.hot.accept("./StoreItem.vue?vue&type=template&id=569ef91e&scoped=true&", function () {
      api.rerender('569ef91e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SAdmin/StoreItem.vue"
export default component.exports